module.exports = {"540622100":"比如镇","540622101":"夏曲镇","540622201":"白嘎乡","540622202":"达塘乡","540622203":"恰则乡","540622204":"扎拉乡","540622207":"羊秀乡","540622208":"香曲乡","540622209":"良曲乡","540622210":"茶曲乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540622.json
// module id = 2737
// module chunks = 0